import { controls,grouped } from "../controls";
const product_parameters = {
label: "Product Parameters",
pageLabel: "Product Parameters",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Installment Frequency",star:false}),
...controls.autoComplete({tab: "general", name: "installment_frequency_code", width: "col-sm-2",controlType: "InstallmentFrequency"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Installment Type",star:false}),
...controls.autoComplete({tab: "general", name: "installment_type_code", width: "col-sm-2",controlType: "InstallmentType"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Interest Frequency",star:false}),
...controls.oc({ tab: "general", c: "InterestFrequency", placeHolder: "Interest Frequency Code", name: "interest_frequency_code",fastpath: "interest_frequencies",autoopen:true,hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "interest_frequency_display"}),
...controls.displayText({ tab: "general", label: "After Mature Rate"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "after_mature_rate",maxlength:8}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Premature Penalty By"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "premature_penalty_by",maxlength:6}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "Start Date",target: "start_date",star:false}),
...controls.magicDate({ tab: "general", name: "start_date", dateType: "ontype" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "End Date",target: "end_date",star:false}),
...controls.magicDate({ tab: "general", name: "end_date", dateType: "ontype" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Min Period Month",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "min_period_month",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Max Period Month",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "max_period_month",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Min Amount",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "min_amount",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Max Amount",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "max_amount",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Amount Steps",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "amount_steps",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Maturity Multiplier",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "maturity_multiplier",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Fix Months",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "fix_months",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Fix Days",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "fix_days",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Separate Int",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "separate_int",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Min Days Closing",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "min_days_closing",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Min Amount Sms",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "min_amount_sms",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Premature Int Rate"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "premature_int_rate",maxlength:8}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Min Cheque Leaves",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "min_cheque_leaves",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "Is Rx After Maturity",default:false, name: "is_rx_after_maturity" }),
...controls.checkBox({ tab: "general", label: "Is Sms",default:false, name: "is_sms" }),
...controls.checkBox({ tab: "general", label: "Has Standing",default:false, name: "has_standing" }),
...controls.checkBox({ tab: "general", label: "Is Auto Calc Maturity",default:false, name: "is_auto_calc_maturity" }),
...controls.checkBox({ tab: "general", label: "Is Compound Int",default:false, name: "is_compound_int" }),
...controls.checkBox({ tab: "general", label: "Is Recurring",default:false, name: "is_recurring" }),
...controls.checkBox({ tab: "general", label: "Is Maturity Fixed",default:false, name: "is_maturity_fixed" }),
...controls.checkBox({ tab: "general", label: "Is Maturity Amount Fixed",default:false, name: "is_maturity_amount_fixed" }),
...controls.checkBox({ tab: "general", label: "Is Premature",default:false, name: "is_premature" }),
...controls.checkBox({ tab: "general", label: "Loan Allowed",default:false, name: "loan_allowed" }),
...controls.checkBox({ tab: "general", label: "Is Close On Zero",default:false, name: "is_close_on_zero" }),
...controls.checkBox({ tab: "general", label: "Is Renewable",default:false, name: "is_renewable" }),
...controls.checkBox({ tab: "general", label: "Is Interest Sms",default:false, name: "is_interest_sms" }),
]
,history:{
perPage: 10,
reportHeader: "Product Parameters",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Installment Frequency Id",accessor: "installment_frequency_id",},
{Header: "Installment Type Id",accessor: "installment_type_id",},
{Header: "Interest Frequency Id",accessor: "interest_frequency_id",},
]}};
export default product_parameters;